import { connect } from 'react-redux'
import AkteCardComponet from './component'

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AkteCardComponet)